<template>
<button @click="openOAuthWindow"
        :class="{ 'is-loading': state === $const.OAUTH_AWAITING_ACTION }"
        class="button">
    Review Permissions
</button>
</template>

<script>
import { mapGetters } from 'vuex'
import * as M from '@/store/mutations'
import * as C from '@shared/constants'
import ls from '@/local-storage'

const env = process.env

export default {
    name: 'OAuthButton',
    props: {
        oauthState: String
    },
    data: () => ({
        state: C.OAUTH_ASK_PERMISSION,
    }),
    computed: {
        ...mapGetters(['isGuanzoUser']),
        oAuthUrl () {
            const url = new URL('https://id.twitch.tv/oauth2/authorize')
            const q = url.searchParams
            q.set('client_id', env.TWITCH_EXT_CLIENT_ID)
            q.set('redirect_uri', `${env.EBS_ORIGIN}/api/oauth-redirect`)
            q.set('response_type', 'code')
            // TODO: Add scopes for bits & subscriber status for a future release.
            q.set('scope', 'moderation:read')
            if (!env.IS_PROD || this.isGuanzoUser) {
                // While testing in dev, always force confirmation
                q.set('force_verify', !env.IS_PROD)
            }

            return url.href
        },
    },
    created () {
        window.addEventListener('message', this.oAuthCallback)
    },
    destroyed () {
        window.removeEventListener('message', this.oAuthCallback)
        this.clearTimers()
    },
    methods: {
        transition (to) {
            this.state = to
            this.$emit('update:oauthState', to)

            // I'd rather use a watcher on this.state, but this component is
            // destroyed after a successful oauth, and the watcher never fires.
            //
            // Client side update only, the oauth flow has already completed
            // on the backend.
            if (to === C.OAUTH_SUCCESS) {
                const channel = { hasOAuthToken: true }
                this.$store.commit(M.UPDATE_CHANNEL, { channel })
                // Hack, to not trigger "you have unsaved changes".
                this.$store.commit(M.UPDATE_LAST_SAVED_CHANNEL, { channel })
            }
        },
        openOAuthWindow () {
            const vm = this
            vm.clearTimers()
            vm.transition(C.OAUTH_AWAITING_ACTION)

            vm.authWindow = window.open(vm.oAuthUrl, '_blank', 'width=500,height=750')

            const onDone = () => {
                vm.clearTimers()
                if (vm.state === C.OAUTH_AWAITING_ACTION) {
                    vm.transition(C.OAUTH_NO_ACTION)
                }
            }

            // https://stackoverflow.com/a/38165968/2498782
            vm.intervalId = setInterval(() => {
                if (vm.authWindow?.closed) {
                    onDone()
                }
            }, 500)

            const maxWaitDuration = 30 * 1000
            vm.timeoutId = setTimeout(onDone, maxWaitDuration)
        },
        oAuthCallback (e) {
            if (e.data?.type !== 'oauthRedirect' || !this.authWindow) { return }
            this.authWindow.close()

            const { isSuccess, errorDesc } = e.data.data
            const didUserDeny = errorDesc === 'The user denied you access'

            let nextState
            if (isSuccess) {
                nextState = C.OAUTH_SUCCESS
            } else if (didUserDeny) {
                nextState = C.OAUTH_DENIED
            } else {
                nextState = C.OAUTH_ERROR
            }

            this.transition(nextState)

            if (isSuccess) {
                ls.setItem(C.OAUTH_LOCAL_STORAGE_KEY, Date.now())
            }
        },
        clearTimers () {
            clearInterval(this.intervalId)
            clearInterval(this.timeoutId)
        },
    }
}
</script>

<style lang="scss" scoped>
.button {
    background: rgb(218, 115, 82);
    background-image: linear-gradient(-131deg, #F9637C 0%, #FF7933 100%);
    color: #F5F5F5;
    &:hover, &:active, &:focus  {
        color: #F5F5F5; // override bulma
    }
}

// https://codepen.io/kocsten/pen/rggjXp
// Modified to always show glow.
// .glow-on-hover {
//     cursor: pointer;
//     position: relative;
//     z-index: 0;
//     border-radius: 10px;
// }
// .glow-on-hover:before {
//     content: '';
//     background: linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000);
//     position: absolute;
//     top: -2px;
//     left:-2px;
//     background-size: 400%;
//     z-index: -1;
//     filter: blur(5px);
//     width: calc(100% + 4px);
//     height: calc(100% + 4px);
//     animation: glowing 20s linear infinite;
//     opacity: 1;
//     transition: opacity .3s ease-in-out;
//     border-radius: 10px;
// }

// .glow-on-hover:active {
//     color: #000
// }

// .glow-on-hover:after {
//     z-index: -1;
//     content: '';
//     position: absolute;
//     width: 100%;
//     background-image: linear-gradient(-131deg, #F9637C 0%, #FF7933 100%);
//     height: 100%;
//     left: 0;
//     top: 0;
//     border-radius: 10px;
// }
// @keyframes glowing {
//     0% { background-position: 0 0; }
//     50% { background-position: 400% 0; }
//     100% { background-position: 0 0; }
// }
</style>
